module.exports = __webpack_public_path__ + "mbox.png?6c83ea5f25276eb877c7e3dfbd236275";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/mbox.png
// module id = 1153
// module chunks = 2